import { render, staticRenderFns } from "./AwardSetting.vue?vue&type=template&id=4a05e54c&scoped=true&"
import script from "./AwardSetting.vue?vue&type=script&lang=js&"
export * from "./AwardSetting.vue?vue&type=script&lang=js&"
import style0 from "./AwardSetting.vue?vue&type=style&index=0&id=4a05e54c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05e54c",
  null
  
)

export default component.exports